(()=>{
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const initialize=(root=document)=>{
  root.querySelectorAll('[data-ag-gallery]').forEach(gallery=>{
   if(gallery.dataset.agReady)return;
   gallery.dataset.agReady='true';
   const track=gallery.querySelector('[data-ag-track]');
   const slides=[...gallery.querySelectorAll('[data-ag-slide]')];
   const thumbs=[...gallery.querySelectorAll('[data-ag-thumb]')];
   const previous=gallery.querySelector('[data-ag-previous]');
   const next=gallery.querySelector('[data-ag-next]');
   const count=gallery.querySelector('[data-ag-count]');
   const dialog=gallery.querySelector('dialog');
   let selected=0;
   let frame;
   const update=()=>{
    selected=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));
    thumbs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===selected)));
    slides.forEach((slide,i)=>{slide.querySelector('button').tabIndex=i===selected?0:-1;});
    count.textContent=String(selected+1);
    previous.disabled=selected===0;
    next.disabled=selected===slides.length-1;
   };
   const choose=i=>track.scrollTo({left:track.clientWidth*Math.max(0,Math.min(slides.length-1,i)),behavior:reduced.matches?'instant':'smooth'});
   thumbs.forEach((button,i)=>button.addEventListener('click',()=>choose(i)));
   previous.addEventListener('click',()=>choose(selected-1));
   next.addEventListener('click',()=>choose(selected+1));
   track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});
   track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();choose(selected+(event.key==='ArrowRight'?1:-1));}});
   slides.forEach(slide=>slide.querySelector('button').addEventListener('click',()=>{
    const original=slide.querySelector('img');
    const zoom=dialog.querySelector('img');
    zoom.removeAttribute('srcset');
    zoom.removeAttribute('sizes');
    zoom.loading='eager';
    zoom.src=original.dataset.agFull;
    zoom.width=original.naturalWidth;
    zoom.height=original.naturalHeight;
    zoom.alt=original.alt;
    document.documentElement.classList.add('ag-gallery-open');
    dialog.showModal();
   }));
   dialog.querySelector('button').addEventListener('click',()=>dialog.close());
   dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
   dialog.addEventListener('close',()=>document.documentElement.classList.remove('ag-gallery-open'));
   const onResize=new ResizeObserver(()=>{track.scrollTo({left:track.clientWidth*selected,behavior:'instant'});update();});
   onResize.observe(track);
   const visibility=new IntersectionObserver(entries=>document.documentElement.classList.toggle('ag-viewing-gallery',entries.some(e=>e.isIntersecting)),{threshold:0});
   visibility.observe(gallery);
   document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(gallery)){onResize.disconnect();visibility.disconnect();document.documentElement.classList.remove('ag-viewing-gallery','ag-gallery-open');}},{once:true});
   update();
  });
  root.querySelectorAll('[data-ag-marquee]').forEach(section=>{
   if(section.dataset.agReady)return;
   section.dataset.agReady='true';
   const button=section.querySelector('[data-ag-pause]');
   button.addEventListener('click',()=>{
    const paused=section.dataset.paused!=='true';
    section.dataset.paused=String(paused);
    button.setAttribute('aria-pressed',String(paused));
    button.textContent=paused?button.dataset.resume:button.dataset.pause;
   });
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
